export const getText = (textObj, language) => {
  if (!textObj || typeof textObj !== "object") {
    return "";
  }
  if (textObj[language] !== undefined && textObj[language] !== null && textObj[language] !== "") {
    return textObj[language];
  }
  if (textObj["english"] !== undefined && textObj["english"] !== null) {
    return textObj["english"];
  }
  return "";
};

export const getTranslation = (translations, key, language) => {
  if (!translations || !key || !translations[key]) {
    return "";
  }
  return getText(translations[key], language);
};

export const getHtml = (htmlObj, language) => {
  return { __html: getText(htmlObj, language) };
};

export const getHtmlString = (htmlObj, language) => {
  return getText(htmlObj, language);
};

export const getSafeHtml = (htmlObj, language) => {
  let content = getText(htmlObj, language);
  content = content
    .replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '')
    .replace(/on\w+\s*=\s*["'][^"']*["']/gi, '')
    .replace(/on\w+\s*=\s*[^\s>]+/gi, '')
    .replace(/javascript:/gi, '');
  return { __html: content };
};

export default getText;
